"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchAvailableLessons = exports.fetchAllCustomCourses = exports.fetchDefaultIcon = exports.fetchImages = exports.getCustomCourseById = exports.publishCustomCourse = exports.deleteCustomCourse = exports.updateCustomCourse = exports.createCustomCourse = exports.numOfCustomCoursesAvatars = void 0;
exports.numOfCustomCoursesAvatars = 8;
var defaultResponse = {
    id: 12,
    error: '',
    message: 'Operation successfully completed',
    validationErrors: [{ errorKey: '', inputField: '' }],
    success: true,
};
var createCustomCourse = function () { return defaultResponse; };
exports.createCustomCourse = createCustomCourse;
var updateCustomCourse = function () { return defaultResponse; };
exports.updateCustomCourse = updateCustomCourse;
var deleteCustomCourse = function () { return defaultResponse; };
exports.deleteCustomCourse = deleteCustomCourse;
var publishCustomCourse = function () { return defaultResponse; };
exports.publishCustomCourse = publishCustomCourse;
var getCustomCourseById = function () { return ({
    data: {
        id: 1,
        display_name: 'My Custom Course',
        tagline: 'Learn how to secure Java web applications',
        description: 'Learn about the OWASP Top 10 covering all aspects including the vulnerability, why it happens, explots and defenses.',
        icon_url: '/icons/customCourses/customCourse-1.svg',
        updated_at: new Date('2020-10-22 14:57:54'),
        is_published: true,
        custom_course_lessons: [
            {
                id: 5,
                name: 'autocomplete',
                category: 'Unintended Data Leakage',
                framework: 'android',
                vulnerability: 'enable_autocomplete_fields',
                course_id: 1,
                order: '1',
            },
            {
                id: 3,
                name: 'cached_login_credentials',
                category: 'Unintended Data Leakage',
                framework: 'android',
                vulnerability: 'cached_login_credentials',
                course_id: 1,
                order: '2',
            },
        ],
        creator_id: 1,
    },
}); };
exports.getCustomCourseById = getCustomCourseById;
var fetchImages = function () { return ({
    status: 'ok',
    images: [
        '/icons/customCourses/customCourse-1.svg',
        '/icons/customCourses/customCourse-2.svg',
        '/icons/customCourses/customCourse-3.svg',
        '/icons/customCourses/customCourse-4.svg',
        '/icons/customCourses/customCourse-5.svg',
        '/icons/customCourses/customCourse-6.svg',
        '/icons/customCourses/customCourse-7.svg',
        '/icons/customCourses/customCourse-8.svg',
    ],
}); };
exports.fetchImages = fetchImages;
var fetchDefaultIcon = function () { return ({
    status: 'ok',
    image: '/icons/customCourses/default/custom-course-default.svg',
}); };
exports.fetchDefaultIcon = fetchDefaultIcon;
var fetchAllCustomCourses = function () { return [
    {
        id: 1,
        display_name: 'My Custom Course',
        tagline: 'Learn how to secure Java web applications',
        description: 'Learn about the OWASP Top 10 covering all aspects including the vulnerability, why it happens, explots and defenses.',
        icon_url: '/icons/customCourses/customCourse-1.svg',
        updated_at: new Date('2020-10-22 14:57:54'),
        is_published: true,
        custom_course_lessons: [
            {
                id: 5,
                name: 'autocomplete',
                category: 'Unintended Data Leakage',
                framework: 'android',
                vulnerability: 'enable_autocomplete_fields',
            },
            {
                id: 3,
                name: 'cached_login_credentials',
                category: 'Unintended Data Leakage',
                framework: 'android',
                vulnerability: 'cached_login_credentials',
            },
        ],
        lesson_count: 2,
    },
    {
        id: 2,
        display_name: 'The Best Course',
        tagline: 'Learn how to secure Java web applications',
        description: 'Learn about the OWASP Top 10 covering all aspects including the vulnerability, why it happens, explots and defenses.',
        icon_url: '/icons/customCourses/customCourse-1.svg',
        updated_at: new Date('2020-10-28 14:57:54'),
        is_published: false,
        custom_course_lessons: [
            {
                id: 5,
                name: 'autocomplete',
                category: 'Unintended Data Leakage',
                framework: 'android',
                vulnerability: 'enable_autocomplete_fields',
            },
            {
                id: 3,
                name: 'cached_login_credentials',
                category: 'Unintended Data Leakage',
                framework: 'android',
                vulnerability: 'cached_login_credentials',
            },
        ],
        lesson_count: 2,
    },
]; };
exports.fetchAllCustomCourses = fetchAllCustomCourses;
var fetchAvailableLessons = function () { return ({
    action: 'fetch_available_lessons',
    data: {
        go: [
            {
                course_id: 1,
                course_name: 'Go',
                lesson_id: 1,
                lesson_name: 'SQL Injection',
                lesson_order: '',
                assigned_to_custom_course: false,
                lesson_duration: 10,
                description: 'This is a SQL Injection lesson',
                icon_url: '',
                included_in_courses: ['C/C++'],
            },
        ],
        cplus: [
            {
                course_id: 2,
                course_name: 'C/C++',
                lesson_id: 22,
                lesson_name: 'Interface Tour',
                lesson_order: '',
                assigned_to_custom_course: false,
                lesson_duration: 20,
                description: 'This is an Interface Tour lesson',
                icon_url: '',
                included_in_courses: ['Go'],
            },
        ],
        java: [
            {
                course_id: 3,
                course_name: 'C/C++',
                lesson_id: 23,
                lesson_name: 'Fgvbn Tour',
                lesson_order: '',
                assigned_to_custom_course: false,
                lesson_duration: 5,
                description: 'This is a Fgvbn Tour lesson',
                icon_url: '',
                included_in_courses: ['Go'],
            },
        ],
        php: [
            {
                course_id: 4,
                course_name: 'C/C++',
                lesson_id: 24,
                lesson_name: 'Ahgkh Khjhkj Hkj',
                lesson_order: '',
                assigned_to_custom_course: false,
                lesson_duration: 10,
                description: 'This is an Ahgkh Khjhkj Hkj lesson',
                icon_url: '',
                included_in_courses: [],
            },
        ],
    },
}); };
exports.fetchAvailableLessons = fetchAvailableLessons;
